var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-total" },
    [
      _c("h3", [_vm._v("Общая стоимость")]),
      _vm._l(_vm.groups, function(group) {
        return _c("checkout-total-group", {
          key: group.id,
          ref: "group",
          refInFor: true,
          attrs: { group: group, loading: _vm.isLoaded }
        })
      }),
      _c("div", { staticClass: "checkout-total-final" }, [
        _c("div", [_vm._v("Всего к оплате")]),
        _c("div", { staticClass: "price-rub" }, [
          _vm._v("\n      " + _vm._s(_vm._f("price")(_vm.total)) + "\n    ")
        ])
      ]),
      _c("ui-button", {
        staticClass: "checkout-total__submit",
        attrs: {
          loading: _vm.loading,
          text: _vm.submitText,
          wide: "",
          large: ""
        },
        on: {
          click: function($event) {
            return _vm.$emit("submit")
          }
        }
      }),
      _vm._m(0)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout-total__agreement" }, [
      _vm._v("\n    Нажимая на кнопку «Оформить заказ» вы принимаете условия "),
      _c("a", { attrs: { target: "_blank", href: "/agreement" } }, [
        _vm._v("пользовательского соглашения")
      ]),
      _vm._v(" и\n    "),
      _c("a", { attrs: { target: "_blank", href: "/public_ofert" } }, [
        _vm._v("публичной оферты")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }